import React, { useRef, useEffect, memo } from 'react';
import { Alert } from 'reactstrap';
import { loadMap, initItemsOnMap } from '../utils/map';
import Loading from './Loading';

var _view, _map;

function SnapshotMap({initDefinitionExpression}) {
  const snapshotMapNode = useRef();
  const loadingNode = useRef();
  const noMapResultsNode = useRef();
  const mapLoadError = useRef();
  initDefinitionExpression = initDefinitionExpression ? initDefinitionExpression : "";
  
  useEffect(() => {
    loadMap({mapElt: snapshotMapNode.current, noMapResultsElt: noMapResultsNode.current, loadingElt: loadingNode.current, mapLoadErrorElt: mapLoadError.current, initDefinitionExpression})
    .then(mapView => {
        if (mapView) {
          _view = mapView.view;
          _map = mapView.map;
          initItemsOnMap(_map, _view, initDefinitionExpression, noMapResultsNode.current, mapLoadError.current);
        }
    });
    return () => {
        // Clean up the map view to avoid WebGL overload
        if (_view) {
          _view.destroy();
          _view = null;
        }
      };
  }, [initDefinitionExpression]);

  return (
    <>
        <div className="mapLoadError" ref={mapLoadError}>
          <Alert color="danger">An error has occurred. Please try refreshing the page. If this error persists, please contact the <a href="mailto:transparency@odot.state.or.us">site administrator.</a></Alert>
        </div>
        <div className={"snapshot-map"} data-testid="map" ref={snapshotMapNode} />
        <Loading opRef={loadingNode} snapshotMap={true} />
        <div className="no-map-results snapshot-top" ref={noMapResultsNode}>
          See Project Location for general location information.
        </div>
      </>
  );
}

export default memo(SnapshotMap);